<template>
    <div class="c-video-features">
        <div class="c-video-features__title-wrapper">
            <div class="c-video-features__title">
                <h2 class="title">
                    {{ content.title }}
                </h2>
                <p class="subtitle">
                    {{ content.custom.field1 || content.title2 }}
                </p>
            </div>
        </div>

        <y-row class="c-video-features__content-wrapper">
            <y-col
                md="12"
                lg="12"
                class="justify-content-center d-f"
            >
                <div class="c-video-features__content">
                    <h6 class="title">
                        {{ content.synopsis }}
                    </h6>
                    <div
                        class="content"
                        v-html="content.text"
                    />
                </div>
            </y-col>
            <y-col
                md="12"
                lg="12"
            >
                <y-try-it-yourself
                    class="mt-5"
                    iframe
                    iframe-field="field2"
                    :content="content"
                    dont-show-content
                />
            </y-col>
        </y-row>
        <y-row>
            <y-col
                md="12"
                lg="12"
            >
                <div class="w-100 d-f justify-content-center">
                    <y-button
                        v-if="content.custom && content.custom['button-link']"
                        :tag="isLink(content.custom['button-link']) ? 'a' : 'router-link'"
                        color="primary"
                        class="start-building-btn mt-5"
                        :href="content.custom['button-link']"
                        :to="content.custom['button-link']"
                    >
                        {{ content.custom['button-title'] }}
                    </y-button>
                </div>
            </y-col>
        </y-row>
    </div>
</template>

<script>
    import { isLink } from '@/helpers/helpers';
    import YTryItYourself from '@/modules/home/components/TryItYourself/Index.vue';

    export default {
        name      : 'VideoAndFeatures',
        components: {
            YTryItYourself,
        },
        props: {
            content: Object,
        },
        methods: {
            isLink,
        },
    };
</script>

<style lang="scss" src="./index.scss"></style>
